import React from 'react';
import classNames from 'classnames';

import { InfoRowProps } from '../types';
import styles from './styles.module.css';

export const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  labelAddon,
  boldLabel = false,
  boldValue = false,
  'data-testid': testId = 'info-row',
}) => {
  return (
    <div className={styles.infoRow} data-testid={testId}>
      <span
        className={classNames(styles.label, {
          [styles.labelBold]: boldLabel,
        })}
        data-testid={`${testId}-label`}
      >
        {label}
      </span>
      {labelAddon}
      <span
        className={classNames(styles.value, {
          [styles.valueBold]: boldValue,
        })}
        data-testid={`${testId}-value`}
      >
        {value}
      </span>
    </div>
  );
};
